import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setActivePageId } from '@/store/slice';
import { Header } from '@components';
import { ToastContainer } from 'react-toastify';

export const Dashboard: React.FC = () => {
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(setActivePageId(1));
	});

	return (
		<div>
			<ToastContainer />
			<Header />
			<div>
				<Outlet />
			</div>
		</div>
	);
};
